import React, { useRef } from 'react';
import Alert from './Alert';

function Dialog({ isOpen, body, onClose, alert, setAlert, email }) {
  const element = useRef(null);

  let text = <></>;

  switch (alert) {
    case 'newCode':
      text = (
        <p className="text-center text-sm md:text-base">
          Your new code has been sent to {email} <br /> and will be valid for the next 20 minutes.
        </p>
      );
      break;
    case 'failure':
      text = (
        <p className="text-center text-sm md:text-base">Verification Failed: Incorrect code</p>
      );
      break;
    case 'noNewCode':
      text = (
        <p className="text-center text-sm md:text-base">
          Verification Failed: Unable to send new code
        </p>
      );
      break;
    default:
      text = alert?.text || '';
      break;
  }

  return (
    <dialog
      open={isOpen}
      className="absolute top-0 pt-4 sm:pt-0 w-screen h-screen bg-transparent z-[3000]"
      ref={element}
      onClose={onClose}>
      <div className="flex flex-col h-screen justify-center items-center ">
        <div className="relative w-[95%] sm:w-[500px] p-6 sm:p-14 z-[1000] bg-white overflow-scroll">
          <button onClick={onClose} className="absolute top-2.5 right-2.5 text-xs md:text-base">
            <span className="h-7 w-7 md:h-10 md:w-10 flex justify-center items-center border-none text-sm">
              X
            </span>
          </button>
          {body}
          {alert && (
            <Alert setShowAlert={setAlert} loggedIn dialog success={alert === 'newCode'}>
              {text}
            </Alert>
          )}
        </div>
      </div>
      <div
        onClick={onClose}
        className="fixed w-full h-full top-0 left-0 bg-black opacity-70 z-[999]"
      />
    </dialog>
  );
}

export default Dialog;
